export default "<nav>\n    <ul>\n        <li routerLink=\"/admin/news\">NEWS</li>\n        <li>PDF</li>\n    </ul>\n    <span>ESCI</span>\n</nav>"